import { useState } from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PersonIcon from "@mui/icons-material/Person";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArchiveIcon from "@mui/icons-material/Archive";
import { colors } from "./Pipeline.styles";

const PipelineCardMenu = ({
  lead,
  onAction,
  isFirstColumn = false,
  isLastColumn = false,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e) => {
    e?.stopPropagation();
    setAnchorEl(null);
  };

  const handleMenuAction = (e, action) => {
    e.stopPropagation();
    handleClose(e);
    onAction?.(action, lead);
  };

  // Show "Move to Previous Stage" for middle and last columns (not first)
  const showMovePrevious = !isFirstColumn;
  // Show "Move to Next Stage" for first and middle columns (not last)
  const showMoveNext = !isLastColumn;

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClick}
        sx={{
          width: 20,
          height: 20,
          color: colors.textMuted,
          "&:hover": {
            bgcolor: colors.borderLight,
            color: colors.textPrimary,
          },
        }}
      >
        <MoreVertIcon sx={{ fontSize: 16 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        PaperProps={{
          sx: {
            mt: 0.5,
            minWidth: 200,
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            borderRadius: 2,
            "& .MuiMenuItem-root": {
              fontSize: 13,
              py: 1,
              px: 2,
            },
          },
        }}
      >
        <MenuItem onClick={(e) => handleMenuAction(e, "view-profile")}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <PersonIcon sx={{ fontSize: 18, color: colors.textSecondary }} />
          </ListItemIcon>
          <ListItemText primary="View Profile" />
        </MenuItem>

        <Divider sx={{ my: 0.5 }} />

        {/* Move to Previous Stage - shown for middle and last columns */}
        {showMovePrevious && (
          <MenuItem onClick={(e) => handleMenuAction(e, "move-prev-stage")}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <ArrowBackIcon sx={{ fontSize: 18, color: colors.textSecondary }} />
            </ListItemIcon>
            <ListItemText primary="Move to Previous Stage" />
          </MenuItem>
        )}

        {/* Move to Next Stage - shown for first and middle columns */}
        {showMoveNext && (
          <MenuItem onClick={(e) => handleMenuAction(e, "move-next-stage")}>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <ArrowForwardIcon sx={{ fontSize: 18, color: theme.palette.primary.main }} />
            </ListItemIcon>
            <ListItemText
              primary="Move to Next Stage"
              sx={{ color: theme.palette.primary.main }}
            />
          </MenuItem>
        )}

        <Divider sx={{ my: 0.5 }} />

        <MenuItem onClick={(e) => handleMenuAction(e, "archive")}>
          <ListItemIcon sx={{ minWidth: 32 }}>
            <ArchiveIcon sx={{ fontSize: 18, color: "#DC2626" }} />
          </ListItemIcon>
          <ListItemText primary="Archive" sx={{ color: "#DC2626" }} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default PipelineCardMenu;
